import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CloseIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel">
      <path d="M15.5709 15.0713L8.49982 8.00022L1.49989 1" />
      <path d="M1.50009 15.0713L8.57116 8.00022L15.5711 1" />
    </g>
  </svg>,
  'Close'
);
